import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render shortlisting criteria section for FAQ Page
 */
const ShortListingCriteriaSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="shortlisting-criteria-section-component"
    >
      <AccordionV2
        testId="shortlisting-criteria"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="3. How are the applicants shortlisted?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 pb-2 pt-6">
          <p>
            Shortlisting is based on the eligibility criteria and assessments by
            the judging panel.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ShortListingCriteriaSection;
